// import api
import MsacctAPI from "../../components/Utilities/Loaders";
// import action
import { ActionCreator } from "./ActionCreator";
import { IApiResponseState } from '../../components/Interface/IApiResponseState'

// import action types
import {
  SHOW_API_SUCCESS,
  CLEAR_API_RESPONSE_STATUS,
  SHOW_API_ERROR,
  GET_REVIEWCONTENT,
  GET_REVIEWCONTENTMARKER,
  APPROVE_REVIEWCONTENT,
  GET_REPLACECONTENT,
  GET_RADIOSELECTED
} from "./ActionTypes";
import { IAutoHealingReplacement } from "../../components/Interface/View/IAutoHealingView";
import { IAutoHealingSubmitPayload } from "../../components/Interface/Params/IAutoHealingPayload";

// create an API instance
const api = new MsacctAPI();

export function getAPIService() {
  return api
}

export async function* clearApiResponseStatusAction(): ActionCreator {
  yield {
    type: CLEAR_API_RESPONSE_STATUS
  };
}

export async function* clearApiSuccess(): ActionCreator {
  yield {
    type: SHOW_API_SUCCESS
  };
}

/**
 * Get review content
 * @param taskName 
 */
export async function* getReviewContent(link: string, traceID: string, curationID: string): ActionCreator {
  try {
    let reviewContent = await api.autoHealingService.getReviewContent(link, traceID,curationID)

    yield {
      type: GET_REVIEWCONTENT,
      reviewContent
    }
  }
  catch (error) {
    
    const apiResponseState: IApiResponseState = {
      ErrorMessage: error && error.errorMessage,
      StatusCode: error && error.statusCode,
      showErrorDailog: true,
      showSuccessDailog: false,
      ApiUrl: '/api/autohealing/reviewdetails'
    }

    console.log("Chiron api error", apiResponseState)

    yield {
      type: SHOW_API_ERROR,
      apiResponseState
    }
  }
}

export async function* getReplaceContent(replaceParams: IAutoHealingReplacement): ActionCreator {
    try {
        let replaceContent = await api.autoHealingService.getReplaceContent(replaceParams)
        yield {
            type: GET_REPLACECONTENT,
            replaceContent
        }
    }
    catch (error) {

        const apiResponseState: IApiResponseState = {
            ErrorMessage: error && error.errorMessage,
            StatusCode: error && error.statusCode,
            showErrorDailog: true,
            showSuccessDailog: false,
            ApiUrl: '/api/autohealing/applyreplacement'
        }

        console.log("Chiron api error", apiResponseState)

        yield {
            type: SHOW_API_ERROR,
            apiResponseState
        }
    }
}

/**
 * Delete a data source
 * @param taskName 
 */
export async function* approveReviewContent(approveParams: IAutoHealingSubmitPayload): ActionCreator {
  await api.autoHealingService.approveReviewContent(approveParams)

  yield {
    type: APPROVE_REVIEWCONTENT
  }
}

export async function* GetRadioSelectedAction(radioSelected:string): ActionCreator {
  yield {
    type: GET_RADIOSELECTED,
    radioSelected
  };
}

///////Hackathon code start here
/**
 * Get review content
 * @param taskName 
 */
export async function* getHackathonReviewContent(link: string, traceID: string, curationID: string): ActionCreator {
  try {
    let reviewContent = await api.autoHealingService.getHackathonReviewContent(link, traceID,curationID)

    yield {
      type: GET_REVIEWCONTENT,
      reviewContent
    }
  }
  catch (error) {
    
    const apiResponseState: IApiResponseState = {
      ErrorMessage: error && error.errorMessage,
      StatusCode: error && error.statusCode,
      showErrorDailog: true,
      showSuccessDailog: false,
      ApiUrl: '/api/hackathon/reviewdetails'
    }

    console.log("Chiron api error", apiResponseState)

    yield {
      type: SHOW_API_ERROR,
      apiResponseState
    }
  }
}

export async function* getHackathonReplaceContent(replaceParams: IAutoHealingReplacement): ActionCreator {
  try {
      let replaceContent = await api.autoHealingService.getHackathonReplaceContent(replaceParams)
      yield {
          type: GET_REPLACECONTENT,
          replaceContent
      }
  }
  catch (error) {

      const apiResponseState: IApiResponseState = {
          ErrorMessage: error && error.errorMessage,
          StatusCode: error && error.statusCode,
          showErrorDailog: true,
          showSuccessDailog: false,
          ApiUrl: '/api/autohealing/applyreplacement'
      }

      console.log("Chiron api error", apiResponseState)

      yield {
          type: SHOW_API_ERROR,
          apiResponseState
      }
  }
}

/**
 * Delete a data source
 * @param taskName 
 */
export async function* approveHackathonReviewContent(approveParams: IAutoHealingSubmitPayload): ActionCreator {
  await api.autoHealingService.approveHackathonReviewContent(approveParams)

  yield {
    type: APPROVE_REVIEWCONTENT
  }
}


export async function* getContentMarkerReview(link: string, traceID: string, curationID: string, datamart: string): ActionCreator {
  try {
    let reviewContentMarker = await api.autoHealingService.getContentMarkerReview(link, traceID, curationID, datamart)

    yield {
      type: GET_REVIEWCONTENTMARKER,
      reviewContentMarker
    }
  }
  catch (error) {
    
    const apiResponseState: IApiResponseState = {
      ErrorMessage: error && error.errorMessage,
      StatusCode: error && error.statusCode,
      showErrorDailog: true,
      showSuccessDailog: false,
      ApiUrl: '/api/autohealing/reviewdetails'
    }

    console.log("Chiron api error", apiResponseState)

    yield {
      type: SHOW_API_ERROR,
      apiResponseState
    }
  }
}

export function getMakeasReviewed(params: any) {
    return api.autoHealingService.getMakeasReviewed(params)
}

export function getArchiveArticle(params: any) {
  return api.autoHealingService.getArchiveArticle(params)
}

export function getImproveArticle(params: any) {
  return api.autoHealingService.getImproveArticle(params)
}

export function getReviewhistory(link: string, traceID: string) {
  return api.autoHealingService.getReviewhistory(link, traceID)
}

export function getCorrectOwner(params: any) {
  return api.autoHealingService.getCorrectOwner(params)
}

export function getCorrectOwnerData(traceID: string) {
  return api.autoHealingService.getCorrectOwnerData(traceID)
}

export function getAuthandstatus(ticketGuid: string) {
  return api.autoHealingService.getAuthandstatus(ticketGuid)
}

export function getReviewHistoryLog(params: any) {
  return api.autoHealingService.getReviewHistoryLog(params)
}

export function getPlanningCategoryTree() {
  return api.autoHealingService.getPlanningCategoryTree()
}

export function correctPlanningCategory(data: any) {
  return api.autoHealingService.correctPlanningCategory(data)
}